import { WritableSignal } from '@angular/core'

export interface Searchable<R> {
  offset: WritableSignal<number>;
  limit: WritableSignal<number>;
  searchPage(): Promise<{
    data: {
      [key in string]: {
        items?: R[];
      };
    }
  }>;
}

export async function fetchAllInBatches<R>(service: Searchable<R>, key: string): Promise<R[]> {
  service.limit.set(200)
  service.offset.set(0)

  let items: R[] = []
  let total = 0
  do {


    const result = await service.searchPage()

    items = items.concat(result.data[key]?.items || [])
    total = result.data[key]?.items?.length ?? items.length
    service.offset.set(service.offset() + total)

  } while (total >= service.limit())

  return items
}
